// extracted by mini-css-extract-plugin
export var root = "_38474eac85109342d78c8e25e94d5759-css";
export var card = "_373c63b27dd52379d2c63da9eece8668-css";